export default __webpack_public_path__ + "static/media/330_dummy2016-kunstshop01-mobile-de.a7498bea.png";